import { render } from "./Auth.vue?vue&type=template&id=6e0d9164&ts=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=6e0d9164&lang=css"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__